/**
* DevExpress Analytics (core\internal\_isDefined.js)
* Version:  24.1.7
* Build date: Oct 28, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
export function isDefined(object) {
    return null !== object && void 0 !== object && Object.keys(object).length > 0;
}
